<div class="container">
  <div class="cards-grid">
    <div *ngFor="let card of menu; let i = index" class="card" [class.collapsed]="!card.expanded"
      [class.expanded]="card.expanded">
      <div class="card-header" [class.card-header-enabled]="!!card.path" [class.card-header-disabled]="!card.path"
        (click)="toggleCard(i, $event)" (mouseover)="expandCard(i, $event)"
        (mousedown)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <div class="header-content">
          <span class="card-arrow" [class.open]="card.expanded">▼</span>
          <h2>{{ card.label }}</h2>
        </div>
      </div>
      <div class="card-content" *ngIf="card.expanded">
        <ul class="menu">
          <ng-container *ngTemplateOutlet="recursiveMenu; context:{ $implicit: card.children }">
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div>

<ng-template #recursiveMenu let-nodes>
  <li *ngFor="let node of nodes" class="menu-item" [class.has-children]="node.children">
    <div class="label" [class.path-enabled]="hasNavigablePath(node)" [class.path-disabled]="!hasNavigablePath(node)"
      (click)="handleNodeClick(node, nodes, $event)"
      (mouseover)="expandNode(node, nodes, $event)" (mousedown)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()">
      {{ node.label }}
      <!-- Show action text if exists -->
      <span class="action-text" *ngIf="node.action">
        ({{ node.action }})
      </span>
      <!-- Arrow if children exist -->
      <span class="arrow" *ngIf="node.children" [class.open]="node.expanded">▼</span>
    </div>

    <!-- Recursive Submenu -->
    <ul *ngIf="node.children && node.expanded" class="submenu">
      <ng-container *ngTemplateOutlet="recursiveMenu; context:{ $implicit: node.children }">
      </ng-container>
    </ul>
  </li>
</ng-template>
